import { render } from "./Renovacion.vue?vue&type=template&id=5a5cb50b&scoped=true"
import script from "./Renovacion.vue?vue&type=script&lang=js"
export * from "./Renovacion.vue?vue&type=script&lang=js"

import "./Renovacion.vue?vue&type=style&index=0&id=5a5cb50b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a5cb50b"

export default script